module.exports = __webpack_public_path__ + "static/media/whatsappForFormChacked.d9d4716c.svg";